import React from 'react';
import useOrganizationGroups from '../../../../../../hooks/api/useOrganizationGroups';
import { Form } from '../../../../../v2BaseComponents/Form';
import { APITypes } from '../../../../../../primary-record-types';
import GroupFields from '../../../../../shared/Groups/GroupFields';
import { useIsDisabledByParent } from '../../../../../v2BaseComponents/IsDisabledProvider';
import SideDrawerFormContainer, {
    ConfirmDirtyStateFormCloseContainer,
    SideDrawerDirtyFormExitValidationTracker,
} from '../../../../../v2BaseComponents/Form/SideDrawerFormContainer';

export type AddGroupSideDrawerContentOwnProps = {
    onClose: (force: boolean) => void;
};

export type AddGroupSideDrawerContentProps = AddGroupSideDrawerContentOwnProps;

const initialValues: APITypes.organizationService.CreateOrganizationGroupRequest = {
    name: '',
    description: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
};

const AddGroupSideDrawerContent: React.FC<AddGroupSideDrawerContentProps> = ({ onClose }) => {
    const { isCreatingGroup, createGroup } = useOrganizationGroups({ onCreateGroupSuccess: () => onClose(true) });
    const isDisabled = useIsDisabledByParent(isCreatingGroup);
    return (
        <ConfirmDirtyStateFormCloseContainer>
            <Form
                fillContainer
                initialValues={initialValues}
                onSubmit={createGroup}
                isDisabled={isDisabled}
                forceStackFields
            >
                {({ isSubmitting, handleSubmit }) => (
                    <SideDrawerFormContainer
                        isDisabled={isDisabled || isSubmitting}
                        onSubmit={handleSubmit}
                        onCancel={() => onClose(true)}
                    >
                        <SideDrawerDirtyFormExitValidationTracker />
                        <GroupFields isDisabled={isDisabled || isSubmitting} />
                    </SideDrawerFormContainer>
                )}
            </Form>
        </ConfirmDirtyStateFormCloseContainer>
    );
};

export default React.memo(AddGroupSideDrawerContent);
